<wl-modal (closeModal)="dismissModal()" [modalTitle]="modalTitle()">
  <ng-template wlModalBody>
    @if (calculateContent(); as content) {
      <wl-calculate-container
        [content]="content"
        [isInModal]="true"
      ></wl-calculate-container>
    }
  </ng-template>
</wl-modal>
